import { isObject } from 'lodash-es';
import type { App, Component, Plugin } from 'vue';
import MobileDetect from 'mobile-detect';

// @ts-ignore
function NOOP() {}

function openWindow(
  url: string,
  opt?: {
    target?: '_self' | '_blank' | string;
    noopener?: boolean;
    noreferrer?: boolean;
  },
) {
  const { target = '_blank', noopener = true, noreferrer = true } = opt || {};
  const feature: string[] = [];

  noopener && feature.push('noopener=yes');
  noreferrer && feature.push('noreferrer=yes');

  window.open(url, target, feature.join(','));
}

/**
 * Add the object as a parameter to the URL
 * @param baseUrl url
 * @param obj
 * @returns {string}
 * eg:
 *  let obj = {a: '3', b: '4'}
 *  appendUrlParams('www.google.com', obj)
 *  ==>www.google.com?a=3&b=4
 */
function appendUrlParams(baseUrl: string, obj: any): string {
  let parameters = '';
  for (const key in obj) {
    parameters += key + '=' + encodeURIComponent(obj[key]) + '&';
  }
  parameters = parameters.replace(/&$/, '');
  return /\?$/.test(baseUrl) ? baseUrl + parameters : baseUrl.replace(/\/?$/, '?') + parameters;
}

function deepMerge<T = any>(src: any = {}, target: any = {}): T {
  let key: string;
  for (key in target) {
    src[key] =
      isObject(src[key]) && src[key] !== null
        ? deepMerge(src[key], target[key])
        : (src[key] = target[key]);
  }
  return src;
}

function isUrl(path: string): boolean {
  const reg =
    /(((^https?:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+(?::\d+)?|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)$/;
  return reg.test(path);
}

export const withInstall = <T extends Component>(component: T, alias?: string) => {
  const comp = component as any;
  comp.install = (app: App) => {
    app.component(comp.name || comp.displayName, component);
    if (alias) {
      app.config.globalProperties[alias] = component;
    }
  };
  return component as T & Plugin;
};

/**
 * 判断是否为PC端
 */
export function isPC(): boolean {
  const md = new MobileDetect(window.navigator.userAgent);
  return !md.mobile();
}

/**
 * 获取当前页面根路径 #之前的路径
 */
export function getWebRootPath() {
  const { protocol, host, pathname } = window.location;
  return `${protocol}//${host}${pathname}`;
}

export { isUrl, deepMerge, appendUrlParams, openWindow, NOOP };

/**
 * 是否为ipad
 */
export function isIpad(): boolean {
  /*  * ipad环境判断更新  * iOS pre 13 以前以ua作判断，13后以platform及maxTouchPoints做判断  */
  const ipad =
    /ipad/i.test(navigator.userAgent) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  return ipad;
}
